export default {
  appVersion: process.env.REACT_APP_VERSION,
  apiURL: process.env.REACT_APP_API_URL,
  referralCandyAppID: process.env.REACT_APP_REFERRAL_CANDY_APP_ID,
  enableReferralCandy: process.env.REACT_APP_ENABLE_REFRRAL_CANDY === 'true',
};
